import React, { Component } from "react";
import trash from "views/profile/img/delete-2.svg";
import edit from "views/profile/img/edit.svg";
import { ChevronLeft, ChevronDown } from "react-feather";
import { getLANGUAGEMASTERAction } from 'store/masters'
// import {} from 'store/userWalkthrough'
import { getlanguageAction, setLanguageAction, getSkillAction, getCertificationAction, getPublicationAction } from 'store/userWalkthrough'
import { connect } from 'react-redux'
import Skill from "./MiscellaneousComponents/Skill";
import Certificate from "./MiscellaneousComponents/Certificate";
import Publication from "./MiscellaneousComponents/Publication";
import kyc from "views/profile/img/kyc/kyc.png";
class Experience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddDetails: true,
      LanguageRID: 0,
      LanguageID: "",
      MotherTongue: 0,
      ReadLevel: 0,
      WriteLevel: 0,
      SpeakLevel: 0,
      UnderstandingLevel: "",
      skillviewflag: true,
      "MiddleName": "",
      "FatherName": "",
      "FatherOccupation": "",
      "FamilyIncome": "",
      "ExtraCurrInterHobbi": "",
      "PhysicalDisabilities": "",
      "ChallengingSituations": "",
      "BusiProParticipate": "",
      "SignAchivement": ""

    };
  }
  async saveAcademicOthers() {
    let LanguageJson = this.props.LANGUAGEDETAILS ? this.props.LANGUAGEDETAILS.Data ? this.props.LANGUAGEDETAILS.Data.LanguageData.length > 0 ?
      this.props.LANGUAGEDETAILS.Data.LanguageData : [] : [] : [];
    var obj = {
      CandidateNo: this.props.Auth.HCID,
      LanguageData: LanguageJson,
      "MiddleName": this.state.MiddleName,
      "FatherName": this.state.FatherName,
      "FatherOccupation": this.state.FatherOccupation,
      "FamilyIncome": this.state.FamilyIncome,
      "ExtraCurrInterHobbi": this.state.ExtraCurrInterHobbi,
      "PhysicalDisabilities": this.state.PhysicalDisabilities,
      "ChallengingSituations": this.state.ChallengingSituations,
      "BusiProParticipate": this.state.BusiProParticipate,
      "SignAchivement": this.state.SignAchivement
    };
    let response = await this.props.setLanguageAction(obj);
    if (response.ResponseCode == 100) {
      this.setState({ isAddDetails: true });
      this.props.getlanguageAction(this.props.Auth.HCID);
    } else {
      alert(response.ResponseMessage)
    }

  }
  setSkillView() {
    this.setState({ skillviewflag: !this.state.skillviewflag });
  }
  async saveAcademic() {
    let LanguageJson = [{
      LanguageRID: this.state.LanguageRID,
      LanguageID: this.state.LanguageID,
      MotherTongue: this.state.MotherTongue,
      ReadLevel: this.state.ReadLevel ? 1 : 0,
      WriteLevel: this.state.WriteLevel ? 1 : 0,
      SpeakLevel: this.state.SpeakLevel ? 1 : 0,
      UnderstandingLevel: this.state.UnderstandingLevel
    }]

    var obj = {
      CandidateNo: this.props.Auth.HCID,
      LanguageData: LanguageJson,
      "MiddleName": this.state.MiddleName,
      "FatherName": this.state.FatherName,
      "FatherOccupation": this.state.FatherOccupation,
      "FamilyIncome": this.state.FamilyIncome,
      "ExtraCurrInterHobbi": this.state.ExtraCurrInterHobbi,
      "PhysicalDisabilities": this.state.PhysicalDisabilities,
      "ChallengingSituations": this.state.ChallengingSituations,
      "BusiProParticipate": this.state.BusiProParticipate,
      "SignAchivement": this.state.SignAchivement
    };
    let response = await this.props.setLanguageAction(obj);
    if (response.ResponseCode == 100) {
      await this.setState({ isAddDetails: true });
      await this.props.getlanguageAction(this.props.Auth.HCID);
      await this.setOtherDetails();
    } else {
      alert(response.ResponseMessage)
    }

  }
  async setOtherDetails() {
    if (this.props.LANGUAGEDETAILS) {
      this.setState({
        "MiddleName": this.props.LANGUAGEDETAILS.Data.MiddleName,
        "FatherName": this.props.LANGUAGEDETAILS.Data.FatherName,
        "FatherOccupation": this.props.LANGUAGEDETAILS.Data.FatherOccupation,
        "FamilyIncome": this.props.LANGUAGEDETAILS.Data.FamilyIncome,
        "ExtraCurrInterHobbi": this.props.LANGUAGEDETAILS.Data.ExtraCurrInterHobbi,
        "PhysicalDisabilities": this.props.LANGUAGEDETAILS.Data.PhysicalDisabilities,
        "ChallengingSituations": this.props.LANGUAGEDETAILS.Data.ChallengingSituations,
        "BusiProParticipate": this.props.LANGUAGEDETAILS.Data.BusiProParticipate,
        "SignAchivement": this.props.LANGUAGEDETAILS.Data.SignAchivement
      })
    }
  }
  async componentDidMount() {
    let response = await this.props.getLANGUAGEMASTERAction();
    if (response.ResponseCode == 100) {
      this.setOtherDetails();
    }
    let skillResponse = await this.props.getSkillAction(this.props.Auth.HCID);

    let certificationResponse = await this.props.getCertificationAction(
      this.props.Auth.HCID
    );
    let publicationResponse = await this.props.getPublicationAction(
      this.props.Auth.HCID)
  }
  async emptyState() {
    this.setState({
      LanguageRID: 0,
      LanguageID: "",
      MotherTongue: 0,
      ReadLevel: 0,
      WriteLevel: 0,
      SpeakLevel: 0,
      UnderstandingLevel: "",
      // "MiddleName": "",
      // "FatherName": "",
      // "FatherOccupation": "",
      // "FamilyIncome": "",
      // "ExtraCurrInterHobbi": "",
      // "PhysicalDisabilities": "",
      // "ChallengingSituations": "",
      // "BusiProParticipate": "",
      // "SignAchivement": ""
    })
  }
  async editLanguage(x, y) {

    this.setState({
      isAddDetails: false,
      LanguageRID: x.LanguageRID,
      LanguageID: x.LanguageID,
      MotherTongue: 0,
      ReadLevel: x.ReadLevel,
      WriteLevel: x.WriteLevel,
      SpeakLevel: x.SpeakLevel,
      UnderstandingLevel: 0,
      // isAddDetails: false,
      // LanguageRID: y.LanguageRID,
      // LanguageID: y.UnderstandingLevel,
      // MotherTongue: y.UnderstandingLevel,
      // ReadLevel: y.UnderstandingLevel,
      // WriteLevel: y.UnderstandingLevel,
      // SpeakLevel: y.UnderstandingLevel,
      // UnderstandingLevel: y.UnderstandingLevel,
      // "MiddleName": x.MiddleName,
      // "FatherName": x.FatherName,
      // "FatherOccupation": x.FatherOccupation,
      // "FamilyIncome": x.FamilyIncome,
      // "ExtraCurrInterHobbi": x.ExtraCurrInterHobbi,
      // "PhysicalDisabilities": x.PhysicalDisabilities,
      // "ChallengingSituations": x.ChallengingSituations,
      // "BusiProParticipate": x.BusiProParticipate,
      // "SignAchivement": x.SignAchivement

    })


  }
  render() {
    return (
      <card className="rounded-12px  lg:w-full md:w-full bg-white block   mt-2">
        <div className="pb-6">
          {this.state.isAddDetails && (
            <div>
              <div>
                <div className="flex justify-between ">
                  <div className="flex justify-between items-center w-full">
                    <p className="fsize16 text-black font-semibold">
                      Languages
                    </p>

                    <button
                      className="outline-btn fsize16 misc-w158px  font-semibold  uppercase"
                      onClick={() => {
                        this.setState({
                          isAddDetails: !this.state.isAddDetails,
                        });
                        this.emptyState();
                      }
                      }
                    >
                      ADD
                    </button>
                  </div>
                </div>
              </div>

              <div className="lg:grid md:grid  lg:grid-cols-3 md:grid-cols-3 gap-8  mt-4 ">
                
                {/* languages */}
                {this.props.LANGUAGEDETAILS ? this.props.LANGUAGEDETAILS.Data.LanguageData.map((x, index) => {
                  return (
                    <card className="rounded-sm borderblue-t-5px  drop-shadow20 bg-white block px-6 py-4 lg:mb-0 md:mb-0 mb-6 " key={index}>
                      <div className="flex justify-between 	">
                        <p className="text-black font-bold fsize16">{x.LanguageTitle}</p>
                        <div className="flex items-center">
                          {/* <img src={trash} alt="trash" className="w-5 h-5 mr-3" /> */}
                          <img
                            src={edit}
                            alt="edit"
                            onClick={() => this.editLanguage(x, this.props.LANGUAGEDETAILS)}
                            className="text053C6D w-5 h-5 "
                          />
                        </div>
                      </div>
                      <p className="border707070-t opacity-20 my-4 	"></p>
                      <div>
                        <div className="flex justify-between mb-3">
                          <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                            Read
                          </p>
                          <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                            :
                          </p>

                          <p className="text4B4B4B fsize14 opacity-90 w-5/12">
                            {x.ReadLevel == 1 ? "Yes" : "No"}
                          </p>
                        </div>{" "}
                        <div className="flex justify-between mb-3">
                          <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                            Write
                          </p>
                          <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                            :
                          </p>

                          <p className="text4B4B4B fsize14 opacity-90 w-5/12">
                            {x.WriteLevel == 1 ? "Yes" : "No"}
                          </p>
                        </div>
                        <div className="flex justify-between mb-3">
                          <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                            Speak
                          </p>
                          <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                            :
                          </p>

                          <p className="text4B4B4B fsize14 opacity-90 w-5/12">
                            {x.SpeakLevel == 1 ? "Yes" : "No"}
                          </p>
                        </div>
                      </div>
                    </card>
                  )
                }) : ""}
              </div>
               <div className="divider-card-b opacity-30 mt-8 mb-4"></div>

              {!this.props.LANGUAGEDETAILS ?
                <card className="rounded-12px  bg-white block lg:p-0 md:p-0  lg:mt-8 md:mt-8  sm-shadow-none">
                  <div className=" pb-4">
                    {/* <img
                      src={kyc}
                      alt="kyccomplete"
                      className="w-full h-240px mob-ekyc sm-h190px"
                    /> */}

                    <div className="flex justify-center mt-8">
                      {/* <p>No data</p> */}
                      {/* <p className="text-black line-h30 fsize18 sm-fsize14   lg:w-3/4 md:w-3/4 text-center">
                        No language details are present for your profile, please add language details by clicking below.
                      </p> */}
                    </div>
                    {/* <div class="w-full  flex justify-center w-full mt-10">
                      <button className="filled-button w-230px h-47px fsize16 font-semibold rounded-25px"
                        onClick={() => {
                          this.setState({
                            isAddDetails: !this.state.isAddDetails,
                          });
                          this.emptyState();
                        }
                        }>

                        ADD LANGUAGE DETAILS
                      </button>
                    </div> */}
                  </div>
                </card>
                : ""}
              <Skill setSkillView={this.setSkillView.bind(this)} />

              <Certificate setSkillView={this.setSkillView.bind(this)} />

              <Publication setSkillView={this.setSkillView.bind(this)} />

              {/* <div className="gap-8  mt-4 ">
   
                <div className="relative">

                  <div>
                    <div
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        this.setState({
                          isAddExperience: !this.state.isAddExperience,
                        })
                      }
                    >

                      <p className="text-black fsize16 pl-2 font-semibold">
                        Other Deatils
                  </p>
                    </div>

                    <div className="mt-2 lg:w-3/4 md:w-3/4 w-full lg:pl-6 md:pl-6">
                      <div className="lg:flex md:flex items-center mb-1">
                        <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2  lg:pr-4 md:pr-4">
                          <label for="">Middle Name</label>
                          <input
                            type="text"
                            placeholder=""
                            className=" fsize16"
                            value={this.state.MiddleName}
                            onChange={(e) => this.setState({ MiddleName: e.target.value })}
                          />
                        </div>
                        <div class="pt-4  lg:w-1/2 md:w-1/2  lg:pl-4 md:pl-4">
                          <div className="lg:flex md:flex items-center">
                            <div className=" form-group modal-form-cs  lg:w-1/2 md:w-1/2 w-full  lg:pr-3 md:pr-3">
                              <label for="">Father Name</label>

                              <input
                                type="text"
                                placeholder=""
                                className=" fsize16"
                                value={this.state.FatherName}
                                onChange={(e) => this.setState({ FatherName: e.target.value })}
                              />
                            </div>
                            <div class="form-group modal-form-cs  lg:w-1/2 md:w-1/2 w-full  lg:pr-3 md:pr-3">
                              <label for="">Father Occupation</label>

                              <input
                                type="text"
                                placeholder=""
                                className=" fsize16"
                                value={this.state.FatherOccupation}
                                onChange={(e) => this.setState({ FatherOccupation: e.target.value })}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                      <div className="lg:flex md:flex items-center mb-1">
                        <div class="form-group pt-4 modal-form-cs  lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-3">
                          <label for="">Family Income</label>

                          <input
                            type="text"
                            placeholder=""
                            className=" fsize16"
                            value={this.state.FamilyIncome}
                            onChange={(e) => this.setState({ FamilyIncome: e.target.value })}
                          />
                        </div>
                        <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                          <label for="">Hobby</label>

                          <input
                            type="text"
                            placeholder=""
                            className=" fsize16"
                            value={this.state.ExtraCurrInterHobbi}
                            onChange={(e) => this.setState({ ExtraCurrInterHobbi: e.target.value })}
                          />
                        </div>
                      </div>

                      <div className="lg:flex md:flex items-center mb-1">
                        <div class="form-group pt-4 modal-form-cs  lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-3">
                          <label for="">Physical Disabilities</label>

                          <input
                            type="text"
                            placeholder=""
                            className=" fsize16"
                            value={this.state.PhysicalDisabilities}
                            onChange={(e) => this.setState({ PhysicalDisabilities: e.target.value })}
                          />
                        </div>
                        <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">


                          <label for="">Any Challenging Situations</label>

                          <input
                            type="text"
                            placeholder=""
                            className=" fsize16"
                            value={this.state.ChallengingSituations}
                            onChange={(e) => this.setState({ ChallengingSituations: e.target.value })}
                          />

                        </div>
                      </div>
                      <div class="form-group mt-6 modal-form-cs lg:pr-3 md:pr-3 lg:w-1/2 md:w-1/2 w-full">
                        <label for="">BusiProParticipate</label>

                        <div className="text-right sm-flex mt-8">
                          <button className="outline-button outline-border2px w-200px sm-fsize14 h-50px font-semibold rounded-25px fsize16 mr-4">
                            CANCEL
                </button>
                          <button className="filled-button w-200px filled-border2px h-50px sm-fsize14 font-semibold rounded-25px fsize16 ml-4" onClick={() => this.saveAcademicOthers()}>
                            SAVE
                </button>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className="divider-card-b opacity-30 mt-8 mb-4"></div>
                </div>

              </div> */}
            </div>
          )}

          {!this.state.isAddDetails && (
            <div className="relative">
              <div className="transform-tab cursor-pointer lg:block md:block hidden">
                {/* <div className="flex justify-evenly items-center bgFDF1E7 rounded-8px h-41px w-200px">
                  <p className="text-black opacity-65 fsize14 font-semibold ">
                    Open Resume Tab
                  </p>
                  <ChevronDown className="text053C6D" />
                </div> */}
              </div>
              <div>
                <div
                  className="flex items-center cursor-pointer"
                  onClick={() =>
                    this.setState({ isAddDetails: !this.state.isAddDetails })
                  }
                >
                  <ChevronLeft className="text053C6D" />
                  <p className="text-black fsize16 pl-2 font-semibold" onClick={() => this.emptyState()}>
                    Go back
                  </p>
                </div>

                <div className="mt-2 lg:w-3/4 md:w-3/4 w-full lg:pl-6 md:pl-6">
                  <div className=" mb-1">
                    <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2">
                      <label for="">Language</label>

                      <select className="select-dropdown-c fsize15" value={this.state.LanguageID} onChange={(e) => this.setState({ LanguageID: e.target.value })}>
                        <option value="" disabled>Select</option>
                        {this.props.LANGUAGE ? this.props.LANGUAGE.Data ? this.props.LANGUAGE.Data.map((x) => {

                          return (
                            <option value={x.Value}>{x.Title}</option>

                          )
                        }) : "" : ""
                        }
                      </select>
                    </div>
                  </div>

                  <div className="lg:flex md:flex lg:justify-between  lg:w-2/5 md:w-2/5  lg:mt-6 md:mt-6 mt-8">
                    <div className="sm-h50px">
                      <label class="custcheckbox">
                        <p className="text-black fsize16 absolute top--5px  ml-3">
                          Read
                        </p>
                        <input type="checkbox"
                          checked={this.state.ReadLevel == 1 ? true : false}

                          value={this.state.ReadLevel}
                          onChange={(e) => this.setState({ ReadLevel: !this.state.ReadLevel })}
                        />
                        <span class="overhide-span"></span>
                      </label>
                    </div>
                    <div className="sm-h50px">
                      <label class="custcheckbox">
                        <p className="text-black fsize16 absolute top--5px ml-3">
                          Write
                        </p>
                        <input type="checkbox"
                          value={this.state.WriteLevel}
                          checked={this.state.WriteLevel == 1 ? true : false}

                          onChange={(e) => this.setState({ WriteLevel: !this.state.WriteLevel })}
                        />
                        <span class="overhide-span"></span>
                      </label>
                    </div>
                    <div className="sm-h50px">
                      <label class="custcheckbox">
                        <p className="text-black fsize16 top--5px absolute ml-3">
                          Speak
                        </p>
                        <input type="checkbox"
                          value={this.state.SpeakLevel}
                          checked={this.state.SpeakLevel == 1 ? true : false}

                          onChange={(e) => this.setState({ SpeakLevel: !this.state.SpeakLevel })}
                        />
                        <span class="overhide-span"></span>
                      </label>
                    </div>
                  </div>
                </div>

              </div>

              <div className="text-right sm-flex lg:mt-16 md:mt-16 mt-10">
                <button className="outline-button outline-border2px mis-add-btn w-200px sm-fsize14 h-50px font-semibold rounded-25px fsize16 mr-4">
                  CANCEL
                </button>
                <button className="filled-button w-200px filled-border2px sm-fsize14 h-50px  font-semibold rounded-25px fsize16 ml-4" onClick={() => this.saveAcademic()}>
                  SAVE
                </button>
              </div>
            </div>

          )}

        </div>
      </card>
    );
  }
}

{/* <div className="divider-card-b opacity-30 mt-8 mb-4"></div> */ }


const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
    LANGUAGEDETAILS: state.userWalkthrough.info.LANGUAGEDETAILS,
    LANGUAGE: state.master.info.LANGUAGE
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getlanguageAction: async (payload) => await dispatch(getlanguageAction(payload)),
    setLanguageAction: async (payload) => await dispatch(setLanguageAction(payload)),
    getLANGUAGEMASTERAction: async (payload) => await dispatch(getLANGUAGEMASTERAction(payload)),
    getSkillAction: async (payload) => await dispatch(getSkillAction(payload)),
    getCertificationAction: async (payload) =>
      await dispatch(getCertificationAction(payload)),
    getPublicationAction: async (payload) =>
      await dispatch(getPublicationAction(payload)),


  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Experience);

